import React from 'react';
import { Dimensions, FlatList, StyleSheet, TouchableOpacity } from 'react-native';
import theme from '../../constants/theme.style';
import ProfileAvatar from '../profileAvatar/ProfileAvatar';

const { width, height } = Dimensions.get('window');

const styles = StyleSheet.create({
  list: {
    backgroundColor: theme.GREEN_WARM_COLOR,
    borderTopLeftRadius: theme.BUTTON_BORDER_RADIUS,
    borderBottomLeftRadius: theme.BUTTON_BORDER_RADIUS,
    borderBottomRightRadius: theme.BUTTON_BORDER_RADIUS,
    maxHeight: height * 0.5,
  },
  listContentContainer: {
    alignItems: 'center',
    padding: width > 900 ? 20 : 10,
  },
  item: {
    margin: theme.CONTAINER_MARGIN / 2,
    backgroundColor: theme.WHITE_COLOR,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    borderWidth: 4,
    borderColor: theme.GREY_LIGHT_COLOR,
    padding: 10,
  },
  itemSelected: {
    borderColor: theme.SECONDARY_COLOR,
  },
  itemImage:
    width > 900
      ? {
          width: 108,
          height: 150,
        }
      : {
          width: width * 0.15,
          height: width * 0.15 * 1.39,
        },
});

export default function ProfileAvatarSelectionList({ items, selected, onSelect }) {
  return (
    <FlatList
      style={styles.list}
      contentContainerStyle={styles.listContentContainer}
      data={items}
      numColumns={3}
      showsHorizontalScrollIndicator={false}
      extraData={selected}
      renderItem={({ item }) => (
        <TouchableOpacity
          style={[styles.item, item.key === selected && styles.itemSelected]}
          testID="defaultavatar"
          onPress={() => {
            onSelect(item.key === selected ? 'undefined' : item.key);
          }}
        >
          <ProfileAvatar avatar={`preview-${item.key}`} style={styles.itemImage} />
        </TouchableOpacity>
      )}
    />
  );
}
